module.exports = __webpack_public_path__ + "img/26.19455889.png";